import type { MailboxInfo } from "owa-client-types";
import { isFrontierPrivateTAPUserEnabled } from "./isFrontierPrivateTAPUserEnabled";
import { isFrontierPublicUserEnabled } from "./isFrontierPublicUserEnabled";
import { isFrontierPrivateStagingUserEnabled } from "./isFrontierPrivateStagingUserEnabled";
import { isFrontierPrivateInfluencerUserEnabled } from "./isFrontierPrivateInfluencerUserEnabled";

// Is draft assistant enabled with frontier branding
export function isDraftAssistantFrontierEnabled(mailboxInfo: MailboxInfo): boolean {
    return (isFrontierPublicUserEnabled(mailboxInfo) ||
        isFrontierPrivateTAPUserEnabled(mailboxInfo) ||
        isFrontierPrivateStagingUserEnabled(mailboxInfo) ||
        isFrontierPrivateInfluencerUserEnabled(mailboxInfo));
}
